<!--  NEW  -->

<div class="modal-header">
	<h2>{{ modalTitles[step - 1] }}</h2>
	<button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<hr />
<div class="modal-body d-flex align-items-center" style="width: 100%; justify-content: center">
	<!-- Step 1: Basic Contract Info -->
	<div id="basic-info" class="full-modal" *ngIf="step == 1 && !loading">
		<form [formGroup]="stepOneForm">
			<div class="row g-3">
				<div class="col-lg-6">
					<div class="mb-3">
						<label class="form-label" for="campaign-name">Campaign Name<span class="text-danger">*</span></label>
						<input type="text" class="form-control" [ngClass]="{ 'is-valid': stepOneForm.get('name')?.touched && validateField(stepOneForm, 'name'), 'is-invalid': stepOneForm.get('name')?.touched && !validateField(stepOneForm, 'name') }" id="campaign-name" placeholder="Enter campaign name" formControlName="name" />
						<div *ngIf="submitted && stepOneForm.get('name')?.errors" class="invalid-feedback">Campaign name is required</div>
					</div>
				</div>

				<div class="col-lg-6">
					<div class="mb-3">
						<label class="form-label" for="timezone">Timezone <span class="text-danger">*</span></label>
						<select class="form-select" id="timezone" formControlName="timezone" [ngClass]="{ 'is-valid': stepOneForm.get('timezone')?.touched && validateField(stepOneForm, 'timezone'), 'is-invalid': stepOneForm.get('timezone')?.touched && !validateField(stepOneForm, 'timezone') }">
							<option value="">Select time zone</option>
							<option *ngFor="let tz of timezones" [value]="tz.shortName">{{ tz.name }}</option>
						</select>
					</div>
				</div>
			</div>

			<div class="row g-3">
				<div class="col-lg-6">
					<div class="mb-3">
						<label class="form-label" for="prospects-type">Prospects Type <span class="text-danger">*</span></label>
						<select class="form-select" id="prospects-type" formControlName="prospects_type" [ngClass]="{ 'is-valid': stepOneForm.get('prospects_type')?.touched && validateField(stepOneForm, 'prospects_type'), 'is-invalid': stepOneForm.get('prospects_type')?.touched && !validateField(stepOneForm, 'prospects_type') }">
							<option value="">Select prospects type</option>
							<option *ngFor="let type of prospectTypes" [value]="type.value">{{ type.label }}</option>
						</select>
						<div *ngIf="submitted && stepOneForm.get('prospects_type')?.errors" class="invalid-feedback">Prospects type is required</div>
					</div>
				</div>

				<div class="col-lg-6">
					<div class="mb-3">
						<label class="form-label" for="industry">Industry</label>
						<select class="form-select" id="industry" formControlName="industry"
							[ngClass]="{ 'is-valid': stepOneForm.get('industry')?.touched && validateField(stepOneForm, 'industry'), 'is-invalid': stepOneForm.get('industry')?.touched && !validateField(stepOneForm, 'industry') }">
							<option value="">Select industry</option>
							<option *ngFor="let industry of industries" [value]="industry.id">
								{{ industry.description }}
							</option>
						</select>
					</div>
				</div>
			</div>

			<div class="row g-3">
				<div class="col-lg-6">
					<div class="mb-3">
						<label class="form-label" for="campaign-alias">Select user owner: </label>
						<select class="form-select" id="campaign-alias" formControlName="user_id" (change)="getUserContracts()"
							[ngClass]="{ 'is-valid': stepOneForm.get('user_id')?.touched && validateField(stepOneForm, 'user_id'), 'is-invalid': stepOneForm.get('user_id')?.touched && !validateField(stepOneForm, 'user_id') }">
							<option value="">Select client alias</option>
							<option *ngFor="let clientUser of clientUsers" [value]="clientUser.id">
								{{ clientUser.name }}
							</option>
						</select>
					</div>
				</div>
				<div class="col-6" *ngIf="showContracts" >
					<label class="form-label" for="campaign-alias">Select Contract:</label>
					<br>
					<label class="text-muted" *ngIf="loadingContracts" style="margin-right: 15px; margin-top: 10px">Loading contracts </label>
					<div class="spinner-border contracts text-dark" role="status" *ngIf="loadingContracts">
						<span class="sr-only">Loading...</span>
					</div>
					<div *ngIf="!loadingContracts">
						<select class="form-select" formControlName="contract_id"
						[ngClass]="{ 'is-valid': stepOneForm.get('contract_id')?.touched && validateField(stepOneForm, 'contract_id'), 'is-invalid': stepOneForm.get('contract_id')?.touched && !validateField(stepOneForm, 'contract_id') }">
							<option value="">Select contract</option>
							<option *ngFor="let contract of userContracts" [value]="contract.id">ID: {{ contract.id }} <span *ngIf="contract.startDate !== '0000-00-00 00:00:00'"> - Start date: {{ contract.startDate | utcToLocal : 'LLL YYYY' }} </span>  <span *ngIf="contract.endDate !== '0000-00-00 00:00:00'"> - End date: {{ contract.endDate | utcToLocal : 'LLL YYYY' }} </span></option>
						</select>
					</div>
				</div>
			</div>

			<div class="row g-3">
				<div class="col-6">
					<h3 class="labels">Appointment Types <span class="text-danger">*</span></h3>
					<div *ngFor="let type of appt_types" class="form-check">
						<input type="checkbox" class="form-check-input" [id]="'appt_type_' + type.id" [value]="type.id" (change)="updateSelectedApptTypes(type.id)" [checked]="stepOneForm.get('appt_types')?.value?.includes(type.id)" [ngClass]="{ 'is-invalid': !stepOneForm.get('appt_types')?.value?.length && stepOneForm.get('appt_types')?.touched }" />
						<label class="form-check-label" [for]="'appt_type_' + type.id">{{ type.description }}</label>
					</div>
					<input type="hidden" formControlName="appt_types" />
				</div>
				<div class="col-6">
					<div class="mb-3">
						<label class="form-label" for="source">Source <span class="text-danger">*</span></label>
						<select class="form-select" id="source" formControlName="source" [ngClass]="{ 'is-valid': stepOneForm.get('source')?.touched && validateField(stepOneForm, 'source'), 'is-invalid': stepOneForm.get('source')?.touched && !validateField(stepOneForm, 'source') }">
							<option value="">Select source</option>
							<option value="401k Depot">401k Depot</option>
							<option value="Toplead">Toplead</option>
							<option value="T3 Direct">T3 Direct</option>
						</select>
						<div *ngIf="stepOneForm.get('source')?.touched && stepOneForm.get('source')?.errors" class="invalid-feedback">Source is required</div>
					</div>
				</div>
			</div>
		</form>
	</div>

	<!-- Step 2: Schedule Information -->
	<div id="schedule-info" class="full-modal" *ngIf="step == 2 && !loading">
		<form [formGroup]="stepTwoForm">
			<div class="row g-3">
				<div class="col-lg-12">
					<div class="mb-3">
						<label class="form-label" for="address-1">Address Line 1 <span class="text-danger">*</span></label>
						<input type="text" class="form-control" id="address-1" placeholder="Enter address" formControlName="address_1" [ngClass]="{ 'is-valid': stepTwoForm.get('address_1')?.touched && validateField(stepTwoForm, 'address_1'), 'is-invalid': stepTwoForm.get('address_1')?.touched && !validateField(stepTwoForm, 'address_1') }" />
					</div>
				</div>

				<div class="col-lg-12">
					<div class="mb-3">
						<label class="form-label" for="address-2">Address Line 2</label>
						<input type="text" class="form-control" id="address-2" placeholder="Enter apartment, suite, etc." formControlName="address_2" />
					</div>
				</div>

				<div class="col-md-6">
					<div class="mb-3">
						<label class="form-label" for="city">City<span class="text-danger">*</span></label>
						<input type="text" class="form-control" id="city" placeholder="Enter city" formControlName="city" [ngClass]="{ 'is-valid': stepTwoForm.get('city')?.touched && validateField(stepTwoForm, 'city'), 'is-invalid': stepTwoForm.get('city')?.touched && !validateField(stepTwoForm, 'city') }" />
						<div *ngIf="submitted && stepTwoForm.get('city')?.errors" class="invalid-feedback">City is required</div>
					</div>
				</div>

				<div class="col-md-3">
					<div class="mb-3">
						<label class="form-label" for="state">State<span class="text-danger">*</span></label>
						<select class="form-select" id="state" formControlName="state" [ngClass]="{ 'is-valid': stepTwoForm.get('state')?.touched && validateField(stepTwoForm, 'state'), 'is-invalid': stepTwoForm.get('state')?.touched && !validateField(stepTwoForm, 'state') }">
							<option value="">Select state</option>
							<option *ngFor="let state of states" [value]="state.shortName">{{ state.name }}</option>
						</select>
						<div *ngIf="submitted && stepTwoForm.get('state')?.errors" class="invalid-feedback">State is required</div>
					</div>
				</div>

				<div class="col-md-3">
					<div class="mb-3">
						<label class="form-label" for="zip">ZIP Code <span class="text-danger">*</span></label>
						<input type="text" class="form-control" id="zip" placeholder="Enter ZIP" formControlName="zip" [ngClass]="{ 'is-valid': stepTwoForm.get('zip')?.touched && validateField(stepTwoForm, 'zip'), 'is-invalid': stepTwoForm.get('zip')?.touched && !validateField(stepTwoForm, 'zip') }" />
					</div>
				</div>

				<div class="col-lg-12">
					<div class="mb-3">
						<label class="form-label" for="website-url">Website URL</label>
						<input type="url" class="form-control" id="website-url" placeholder="Enter website URL" formControlName="website_url" />
					</div>
				</div>

				<div class="col-lg-12">
					<div class="mb-3">
						<label class="form-label" for="additional-calendar-url">Additional Calendar URL</label>
						<input type="url" class="form-control" id="additional-calendar-url" placeholder="Enter calendar URL" formControlName="additional_calendar_url" />
					</div>
				</div>
			</div>
		</form>
	</div>

	<!-- Step 3: Additional Information -->
	<div id="additional-info" class="full-modal" *ngIf="step == 3 && !loading">
		<form [formGroup]="stepThreeForm">

			<div class="row">
				<div class="col-12">
					<div class="mb-3">
						<label class="form-label" for="script">Script</label>
						<textarea class="form-control" id="script" rows="4" placeholder="Enter the campaign script" formControlName="script" [ngClass]="{ 'is-invalid': submitted && stepThreeForm.get('script').errors, 'is-valid': submitted && !stepThreeForm.get('script').errors }"></textarea>
						<div *ngIf="submitted && stepThreeForm.get('script').errors" class="invalid-feedback">Campaign script is required</div>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-12">
					<div class="mb-3">
						<label class="form-label" for="who-we-are">Who We Are</label>
						<textarea class="form-control" id="who-we-are" rows="3" placeholder="Describe your organization" formControlName="who_we_are"></textarea>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-12">
					<div class="mb-3">
						<label class="form-label" for="what-we-do">What We Do</label>
						<textarea class="form-control" id="what-we-do" rows="3" placeholder="Describe your services or products" formControlName="what_we_do"></textarea>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-12">
					<div class="mb-3">
						<label class="form-label" for="why-us">Why Us</label>
						<textarea class="form-control" id="why-us" rows="3" placeholder="Explain your unique value proposition" formControlName="why_us"></textarea>
					</div>
				</div>
			</div>


			<div class="row">
				<div class="col-12">
					<div class="mb-3">
						<label class="form-label" for="email-template">Email Template</label>
						<textarea class="form-control" id="email-template" rows="4" placeholder="Enter email template" formControlName="email_template" [ngClass]="{ 'is-invalid': submitted && stepThreeForm.get('email_template').errors, 'is-valid': submitted && !stepThreeForm.get('email_template').errors }"></textarea>
						<div *ngIf="submitted && stepThreeForm.get('email_template').errors" class="invalid-feedback">Email template is required</div>
					</div>
				</div>
			</div>
		</form>
	</div>

	<!-- Step 4: Additional Information -->
	<div id="additional-info" class="full-modal" *ngIf="step == 4 && !loading">
		<form [formGroup]="stepFourForm">
			<div class="row g-3">
				<div class="col-12">
					<div class="mb-3">
						<label class="form-label" for="campaign-notes">Campaign Notes</label>
						<textarea class="form-control" id="campaign-notes" rows="3" placeholder="Enter any campaign specific notes" formControlName="campaign_notes"></textarea>
					</div>
				</div>

				<div class="col-12">
					<div class="mb-3">
						<label class="form-label" for="billing-notes">Billing Notes</label>
						<textarea class="form-control" id="billing-notes" rows="3" placeholder="Enter billing related notes" formControlName="billing_notes"></textarea>
					</div>
				</div>
			</div>
		</form>
	</div>

	<div id="Company" class="full-modal d-flex justify-content-center align-items-center" *ngIf="loading">
		<div align="center">
			<div class="spinner-border text-primary" role="status">
				<span class="sr-only">Creating new campaign...</span>
			</div>
			<br>
			<h3 class="loader-text">Creating new campaign...</h3>
		</div>
	</div>
</div>
<hr />
<div class="modal-footer">
	<div class="container">
		<div class="row">
			<div class="col-6" align="left">
				<button type="button" class="btn btn-outline-secondary waves-effect waves-light" (click)="prev()" *ngIf="step != 1"><i class="bx bx-arrow-back"></i> Back</button>
			</div>
			<div class="col-6" align="right">
				<button type="button" class="btn btn-secondary waves-effect waves-light" (click)="next()" *ngIf="step != 4">Next</button>
				<button type="button" class="btn btn-secondary waves-effect waves-light" (click)="next()" *ngIf="step == 4" [disabled]="loading">Create Campaign</button>
			</div>
		</div>
	</div>
</div>
